// Imports
import { GetPaymentMethodsResponse } from '../../../../../../shareables/types/api/main/website/member/payment-methods/get';


// Define what a payment method type and its status look like
export type PaymentMethodType = GetPaymentMethodsResponse['paymentMethodTypes'][0];
export type PaymentMethodTypeStatus = 'AVAILABLE' | 'PENDING_VERIFICATION' | 'DISABLED';
export type PaymentMethodTypeStatuses = Record<PaymentMethodType, PaymentMethodTypeStatus>;


/** Determine each payment method type's status */
export default function determinePaymentMethodTypeStatuses(
	paymentMethods: Pick<
		GetPaymentMethodsResponse,
		| 'cardPaymentsDisabled'
		| 'cardPaymentsPendingVerification'
		| 'bankAccountPaymentsDisabled'
		| 'bankAccountPaymentsPendingVerification'
	>
): PaymentMethodTypeStatuses {
	// Determine a single status, since a method pending verification is also disabled
	const determineStatus = (disabled: boolean, pendingVerification: boolean): PaymentMethodTypeStatus => {
		if (!disabled) {
			return 'AVAILABLE';
		}
		
		return pendingVerification ? 'PENDING_VERIFICATION' : 'DISABLED';
	};
	
	
	// Return
	return {
		CARD: determineStatus(paymentMethods.cardPaymentsDisabled, paymentMethods.cardPaymentsPendingVerification),
		BANK_ACCOUNT: determineStatus(
			paymentMethods.bankAccountPaymentsDisabled,
			paymentMethods.bankAccountPaymentsPendingVerification
		),
	};
}
